import html from 'modules/notes/rules/htmlRules'

export const NAME = 'notes'

export const NOTE_ALL_GET = 'employeeNoteAllGet'
export const NOTE_POST = 'employeeNotePost'

export const NOTE_TYPE = 'Note'

export const EMPTY_STATE = html.deserialize('<p></p>')
